import { formValueSelector } from 'redux-form';
export const getGraphQlSelection = (productId, formSection) => ({
  form,
  state
}) => {
  var _formData$value$filte, _formData$value;
  const formData = formValueSelector(form)(state, formSection) || {};
  const cardSelection = ((_formData$value$filte = (_formData$value = formData.value) === null || _formData$value === void 0 ? void 0 : _formData$value.filter(({
    exclude
  }) => !exclude)) !== null && _formData$value$filte !== void 0 ? _formData$value$filte : []).map(({
    value
  }) => {
    return {
      travelerId: Number(value)
    };
  });
  const perTravelerSelection = Object.values(formData).filter(({
    value
  }) => value === 'true').map(({
    id
  }) => ({
    travelerId: String(id)
  }));
  if (!cardSelection.length && !perTravelerSelection.length) {
    return null;
  }
  return {
    productId,
    selectionCabinBaggage: cardSelection.length ? cardSelection : perTravelerSelection
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map